import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'
import Select from 'react-select'
import axiosConfig from '../config/axiosConfig';

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? '#7367f0' : 'white',
        
    }), 
    control: (provided) => ({
        ...provided,
        borderRadius: '0px',
        borderColor: '#7367f0',
        

    })
}

class GroupVRNSelect2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            UserBranchID: this.props.data.selectedBranchId,
            masterdropdownoptions: [
                {value : '1' , label:'Profile'},
                {value : '2' , label:'Activity'},
                {value : '3' , label:'Alerts'}
            ],
            dropDownOptions: [
                { value: '1', label: 'All Vehicles' },
                { value: '2', label: 'Vehicle Group(s)' },
                // { value: '4', label: 'Profile' }
            ],
            logTypeOptions: [],
            vrnOptions: [],
            groupOptions: [],
            groups: [],
            groupIds:'',
            groupText : '',
            vrnIds:'',
            isBaseDropDown : '',
            isMultipGroup: this.props.isMultiInGroup,
            isMultiVehicle: this.props.isMultiInVehicle,
            time: Date()

        };
        this.changeOption = this.changeOption.bind(this)
        this.changeMasterOption = this.changeMasterOption.bind(this)
        this.changeGroup = this.changeGroup.bind(this)
        this.changeVehicle = this.changeVehicle.bind(this)
    }
    
    getUserBranchID(){
        debugger
        return this.props.data.selectedBranchId
    }

    componentWillUnmount() {
        debugger
        clearInterval(this.interval);
      }

    async componentDidMount() {
        //console.log("Group VRN props are : ",this.props.data)
        debugger
        const data = {
            UserBranchID: await this.getUserBranchID(),
        }
        axiosConfig.post('Portal/GetVRNGroupMapping', 
        {
            UserBranchID: this.state.UserBranchID
        })
            .then(res => {
                debugger
                for (var i = 0; i < res.data.groupVRN.length; i++) {
                    this.setState(prevState => ({
                        groups: [...prevState.groups, { value: res.data.groupVRN[i].groupID, label: res.data.groupVRN[i].groupName, vrn: res.data.groupVRN[i].vrnModel }]
                    }))
                }
            })
            .catch(function (error) {
            });

        if (this.props.showVehiclesInDropDown === 'yes') {
            debugger
            this.setState(prevState => ({
                dropDownOptions: [...prevState.dropDownOptions,
                {
                    value: '3',
                    label: 'Vehicle(s)'
                }]
            }))
        }

        this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
    }

    async changeGroup(selectedOption) {             
        debugger
            if(this.props.isMultiInGroup == 'true')
            {
                let groupIds = ''
                let groupText = ''
                {selectedOption.map(o => {
                   groupIds= groupIds + o.value +",";
                   groupText = groupText + o.label + ",";
                   }
                )
                
            }
            
            groupText = groupText.slice(0,-1)
            groupIds=groupIds.slice(0, -1)
            await this.setState(
                {
                    groupIds: groupIds,
                    groupText : groupText
                }
            )
            this.props.onGroupChange(this.state.groupIds,this.state.groupText)
            
        }
        else
        {
            this.props.onGroupChange(selectedOption.value,selectedOption.label)
        }
    }
    
    changeMasterOption(selectedOption){
        debugger
        if(selectedOption.value == '1')
        {
            this.setState({groupOptions: [],
                vrnOptions: []
      })
        }
      
        if( selectedOption.value == '2' || selectedOption.value == '3')
        {
 

           this.setState({
            isBaseDropDown:'true'
        });
        }
        else
        {
            this.setState({
                isBaseDropDown:''
            });
        }

        this.props.onMasterOptionChange(selectedOption.value)

    }
    changeOption(selectedOption) {
        debugger
        if (selectedOption.value == '2') {
            this.setState({
                groupOptions: [],
                vrnOptions: []
            }, function () {
                this.state.groups.map((el, index) => {
                    this.setState(prevState => ({
                        groupOptions: [...prevState.groupOptions,
                        {
                            value: el.value,
                            label: el.label
                        }]
                    }))
                })
            });
        }
        else if (selectedOption.value == '3') {
            debugger
            this.setState({
                groupOptions: [],
                vrnOptions: []
            }, function () {
                this.state.groups.map((el, index) => {
                    return (
                        el.vrn.map((el2, index2) => {
                            this.setState(prevState => ({
                                vrnOptions: [...prevState.vrnOptions,
                                {
                                    value: el2.mappingID,
                                    label: el2.vrn
                                }]
                            }))
                        })
                    )
                })
            });
        }
        else {
            debugger
            this.setState({
                groupOptions: [],
                vrnOptions: []
            })
        }
        debugger
        this.props.onOptionChange(selectedOption.value)
    }


    async changeVehicle(selectedOption) {
        debugger
        if(this.props.isMultiInVehicle == 'true')
        {
            let vrnIds = ''
            {selectedOption.map(o => {
                vrnIds= vrnIds + o.value +",";
               }
            )
            
        }

        vrnIds=vrnIds.slice(0, -1)
        await this.setState(
            {
                vrnIds: vrnIds
            }
        )
        this.props.onVehicleChange(this.state.vrnIds)
        
    }
    else
    {
        this.props.onVehicleChange(selectedOption.value)
    }

       
    }

    render() {
        return (
            <>
                {this.props.showFilterText == 'true'
                    ? <strong className="mt-3 ml-3">Choose Base</strong>
                : <></>

                }
                
                {this.props.isMultiInGroup == 'true'
                    ?
                    <>
                    
                    <Select className="mt-2 col-md-3 col-offset-3"
                    options={this.state.masterdropdownoptions}
                    styles={customStyles}
                    onChange={this.changeMasterOption}
                    defaultValue={{ label: "Profile", value: 1 }}
                    
                />
                
                {this.state.isBaseDropDown == 'true' ?
                    <Select className="mt-2 col-md-3 col-offset-3"
                    options={this.state.dropDownOptions}
                    styles={customStyles}
                    onChange={this.changeOption}
                    defaultValue={{ label: "All Vehicles", value: 3 }}
                    
                />
                :
                ""
                }
                
                </>

                    :  
                    
                    <>
                    <Select className="mt-2 col-md-3 col-offset-3"
                    options={this.state.masterdropdownoptions}
                    styles={customStyles}
                    onChange={this.changeMasterOption}
                    defaultValue={{ label: "Profile", value: 1 }}
                    
                />
                 {this.state.isBaseDropDown == 'true' ?
                    <Select className="mt-2 col-md-3 col-offset-3"
                    options={this.state.dropDownOptions}
                    styles={customStyles}
                    onChange={this.changeOption}
                    defaultValue={{ label: "All Vehicles", value: 3 }}
                    
                />
                :
                ""}
                </>

                }



                {this.props.isMultiInGroup == 'true'
                    ? this.state.groupOptions.length > 0 &&
                    <Select className="mt-2"
                        options={this.state.groupOptions}
                        styles={customStyles}
                        onChange={this.changeGroup}
                        isMulti
                    />

                    : this.state.groupOptions.length > 0 &&
                    <Select className="mt-2 col-md-3 col-offset-3"
                        options={this.state.groupOptions}
                        styles={customStyles}
                        onChange={this.changeGroup}
                        
                    />

                }

                {this.props.isMultiInVehicle == 'true'
                    ? this.state.vrnOptions.length > 0 &&
                    <Select className="mt-2"
                        options={this.state.vrnOptions}
                        styles={customStyles}
                        onChange={this.changeVehicle}
                        isMulti
                        
                    />

                    : this.state.vrnOptions.length > 0 &&
                    <Select className="mt-2 col-md-3 col-offset-3"
                        options={this.state.vrnOptions}
                        styles={customStyles}
                        onChange={this.changeVehicle}
                        
                    />

                }


            </>
        )
    }

}

export default GroupVRNSelect2


